import { z } from "zod";

const schema = z.object({
  jobTitle: z.string().min(1, "Job title is required"),
  jobDescription: z.string().min(1, "Job description is required"),
});

type Schema = z.infer<typeof schema>;

export {
  schema as adminGenerateSampleMatchesFormSchema,
  type Schema as AdminGenerateSampleMatchesFormSchema,
};
